import React from 'react';
import {
  COLOR_STYLE_MAP,
  KnownRequestState,
} from 'works/legacy/components/staffing-request-state';
import { Icon, TimeWithTimeZone } from '@common/components';
import { StaffingRequestState } from 'works/legacy/components/staffing-request-state/staffing-request-state';

export function StateMenuInfo({
  state,
  timeStamp,
  submissionsPaused,
}: {
  state: KnownRequestState;
  timeStamp?: string;
  submissionsPaused: boolean;
}) {
  return (
    <div>
      <div className={`color-${COLOR_STYLE_MAP[state]} state-menu-info__label`}>
        <StaffingRequestState state={state} />
        <Icon icon="chevronDown" size="sm" />
        {submissionsPaused && state === 'OPEN' && (
          <Icon
            icon="doNotEnter"
            color="rubyRed"
            size="sm"
            tooltipText="Not accepting new submissions"
          />
        )}
      </div>
      {timeStamp && (
        <div className="StateBadge">
          <div className="caption">
            <TimeWithTimeZone date={timeStamp} variant="long_format" />
          </div>
        </div>
      )}
      <style jsx>{`
        :global(.state-menu-info__label svg) {
          margin-left: 5px;
        }
      `}</style>
    </div>
  );
}
